// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"cee84764","349":"2e702fbc"}[chunkId] + ".chunk.js";
};